// removed by extract-text-webpack-plugin
module.exports = {"root":"_3Dupa","large":"_1scd5"};